export enum ItemType {
  ACTOR = 'actor',
  PROJECT = 'project',
  RESOURCE = 'resource',
}
